<template>
  <div class="performer-list">
    <span v-for="(performer, index) in filteredPerformerList" :key="performer.people_id">
      <RouterLink :to="{name: 'performerById', params:{ locale: $i18n.localePath(), id: performer.people_id }}"
                  :title="displayPerformerName(performer.people)" class="performer-name"
      >
        {{ displayPerformerName(performer.people) }}
      </RouterLink>
      <span v-if="index < filteredPerformerList.length - 1" class="slash">
        /
      </span>
    </span>
  </div>
</template>
<script>
import { displayPerformerName } from '@/assets/helpers/TrackHelper'

export default {
  name: 'PlaylistTablePerformer',
  components: {},
  directives: {},
  props: {
    performerList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {
    filteredPerformerList() {
      return this.performerList
        .filter((performer, index) => (this.performerList.indexOf(performer) === index) ? performer : null) // filter duplicate in list
        // .sort((a, b) => a.id.toUpperCase() > b.id.toUpperCase() ? -1 : 1) // sort by name
    }
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    displayPerformerName
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.performer-list {
  position: absolute;
  top: 15px;
  width: 100%;
  @include ellipsis-with-nowrap();
  .performer-name {
    @include default-link-hover($grey-7d);
  }
}
</style>
